/**
 * Prépare une photo chat Access / commande :
 * - redimensionne (max 1920px)
 * - convertit en JPEG (affichable partout, évite HEIC opaque)
 * - retourne un File prêt pour FormData
 */
export async function prepareChatImage(file, { maxSide = 1920, quality = 0.85 } = {}) {
  if (!file) throw new Error('Aucun fichier');
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return file;
  }

  const mime = String(file.type || '');
  // Vidéo : ne pas toucher
  if (mime.startsWith('video/')) return file;

  const objectUrl = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error('Image illisible (essaie JPG/PNG)'));
      el.src = objectUrl;
    });

    let { width, height } = img;
    if (!width || !height) throw new Error('Dimensions image invalides');

    if (width > maxSide || height > maxSide) {
      const ratio = Math.min(maxSide / width, maxSide / height);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
    }

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas indisponible');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error('Conversion JPEG échouée'))),
        'image/jpeg',
        quality
      );
    });

    const base = String(file.name || 'photo').replace(/\.[^.]+$/, '') || 'photo';
    return new File([blob], `${base}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
  } finally {
    try { URL.revokeObjectURL(objectUrl); } catch { /* */ }
  }
}
